module.exports = __webpack_public_path__ + "img/8.673ee0f.jpg";